// 由于阿里巴巴采取的全表单动态渲染，有些复杂的表单控件层级也许会很深
// 且有可能控件间需要互相影响
// 所以将阿里巴巴的表单数据采用vuex来管理
const alibabaForm = {
  state: () => ({
    form: {
      categoryIds: []
    }, // 当前阿里巴巴表单
    oriData: {}, // 原数据，detail接口返回的数据
    // 目前后端对一些选项的接口未提供搜索分页功能，
    // 采取前端搜索分页
    optionsMap: {},
    isNew: false, // 是否是新版表单
    specifications: [],
    skuList: [],
  }),
  mutations: {
    setAlibabaIsNew(state, bool) {
      state.isNew = bool
    },
    // 更新form
    updateForm(state, newFormFields) {
      const updateFormFields = { ...newFormFields }
      Object.keys(updateFormFields).forEach(key => {
        // 对于name字段中含有.的进行替换为_____（5个下划线），不然在el-form-item中prop属性时会报错
        if (/\./.test(key)) {
          updateFormFields[key.replaceAll('.', '_____')] = updateFormFields[key]
        }
      })
      state.form = {
        ...state.form,
        ...updateFormFields
      }
    },
    setForm(state, newForm) {
      state.form = {
        ...newForm,
      }
    },
    setOriData(state, data) {
      state.oriData = data
    },
    updateSpecifications(state, data) {
      state.specifications = data
    },
    updateSkuList(state, data) {
      state.skuList = data
    },
    clear(state) {
      state.form = {
        categoryIds: []
      }
      state.oriData = {}
      state.optionsMap = {}
      state.specifications = []
      state.skuList = []
    },
    initOptions(state, { key, options }) {
      state.optionsMap[key] = options
    }
  },
  actions: {
    setOriDetailData({ commit }, data) {
      commit("setOriData", data)
    },
    initAlibabaForm({ commit }, form) {
      commit("setForm", form)
    },
    updateAlibabaForm({ commit }, newFormFields) {
      commit("updateForm", newFormFields)
    },
    updateAlibabaSpecifications({ commit }, data) {
      commit("updateSpecifications", data)
    },
    updateAlibabaSkuList({ commit }, data) {
      commit("updateSkuList", data)
    },
    clearAlibabaInfo({ commit }) {
      commit("clear")
    },
    initAlibabaOptions({ commit }, data) {
      commit("initOptions", data)
    }
  },
  getters: {
    alibabaIsNew(state) {
      return state.isNew
    },
    alibabaForm(state) {
      return state.form
    },
    alibabaData(state) {
      return state.oriData
    },
    alibabaOptions: (state) => ({ key, search }) => {
      if (!state.optionsMap[key]) return false
      return state.optionsMap[key].filter(op => op.displayName.indexOf(search) > -1).slice(0, 99)
    },
    alibabaHasOption: (state) => ({ key, value }) => {
      if (!state.optionsMap[key]) return false
      return state.optionsMap[key].some(op => op.value == value)
    },
    alibabaSpecifications(state) {
      return state.specifications
    },
    alibabaSkuList(state) {
      return state.skuList
    },
  }
}

export default alibabaForm
